import type { MFAttestationSummary } from "state/members/accessReviews";
import { isOwnerSignOff } from "./signOff";

export const reviewSectionCopy = (
  att: Pick<MFAttestationSummary, "reviewType">,
): { kicker: string; title: string; body: string; showSummary: boolean } =>
  isOwnerSignOff(att)
    ? {
        kicker: "Attestation",
        title: "What you're attesting to",
        body: "This system is not reviewed user by user in Ploy. By attesting you confirm that you have reviewed who has access in the system itself and actioned any changes.",
        showSummary: false,
      }
    : {
        kicker: "Review summary",
        title: "What was reviewed",
        body: "Counts from the access review you’re attesting to. Your job is to confirm the review was done, not to re-review individual accounts.",
        showSummary: true,
      };
